import {
  SnmpActionTypes,
  SnmpState,
  GET_SNMP_USERS_FULFILLED,
  GET_SNMP_USER_FULFILLED,
  SELECT_SNMP_USER,
  GET_SNMP_DESTS_FULFILLED,
  GET_SNMP_DEST_FULFILLED,
  SELECT_SNMP_DEST
} from './snmp.types';

export const initialState: SnmpState = {
  snmpUsers: [],
  singleUser: null,
  selectedUser: null,
  snmpDests: [],
  singleDest: null,
  selectedDest: null
};

export default function snmpReducer(
  state = initialState,
  action: SnmpActionTypes
): SnmpState {
  switch (action.type) {
    case GET_SNMP_USERS_FULFILLED:
      return {
        ...state,
        selectedUser: null,
        snmpUsers: action.payload.data.data ?? []
      };

    case GET_SNMP_USER_FULFILLED:
      return {
        ...state,
        singleUser: (action.payload.data.data ?? [])[0]
      };

    case SELECT_SNMP_USER:
      return {
        ...state,
        selectedUser: action.payload
      };

    case GET_SNMP_DESTS_FULFILLED:
      return {
        ...state,
        selectedDest: null,
        snmpDests: action.payload.data.data ?? []
      };

    case GET_SNMP_DEST_FULFILLED:
      return {
        ...state,
        singleDest: (action.payload.data.data ?? [])[0]
      };

    case SELECT_SNMP_DEST:
      return {
        ...state,
        selectedDest: action.payload
      };

    default:
      return state;
  }
}
